module.exports = __webpack_public_path__ + "img/Divii-Lawyers-Reverse.5f731d47.png";